<style src="@/assets/styles/error.styl" lang="stylus"></style>
<style src="@/assets/styles/base/_fonts.styl" lang="stylus" scoped></style>
<template>
  <div id="app" class="cb-hp cb-hp--hidden" tabindex="0" lang="en">
    <div class="cb-hp__wrapper">
      <div class="cb-body" id="cb-body" v-cb-animate="true">
        <div class="cb-body__wrap">
          <div class="cb-error">
            <div class="cb-error__content">
              <div class="cb-error_icon">
                <i class="icon-exclamation-circle"></i>
              </div>
              {{message}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cb-hp__close" @click="close" v-cb-link = "'shadow'" role="button" aria-label="close checkout" data-cb-id="cb_close" v-on:keydown="closeKey">
      <i class="icon-remove cb-hp__close-icon"></i>
    </div>
  </div>
</template>

<script type="text/javascript">
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default {
  data() {
    return {
      internalMessage: ""
    }
  },
  computed: {
    message() {
      if(this.internalMessage) {
        return this.internalMessage;
      } else {
        return "Invalid Url";
      }
    }
  },
  methods: {
    close() {
      window.cbPostMessage("cb.close");
    },
    closeKey(event) {
      if(event.keyCode == 9) {
        document.getElementById("app").focus();
      }
    }
  },
  mounted() {
    let messageElement = document.getElementById("message");
    if(messageElement) {
      this.internalMessage = messageElement.textContent;
    }
    window.cbPostMessage("cb.loaded");
    document.body.addEventListener("keydown", function(event) {
      if (event.keyCode == 27) {
        window.cbPostMessage("cb.close");
      }
    });
  }
}
</script>